import React from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiLabel, SuiField } from '@splashthat/sui';

import FormImagePanel from './FormImagePanel';

const FormImageManager = ({ label }) => (
    <SuiContainer variation="flex-group">
        <SuiLabel text={label} />
        <SuiField fullWidth formElement={<FormImagePanel />} />
    </SuiContainer>
);

FormImageManager.propTypes = {
    label: PropTypes.string,
};

FormImageManager.defaultProps = {
    label: null,
};

export default FormImageManager;
